import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfMediaLinksItemProjectInfoEngagement } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfMediaLinksItemProjectInfoEngagement';

/**
 * 프로젝트 링크인 경우 추가 정보 (우리 사이트 내부 링크)
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfMediaLinksItemProjectInfo = {
  /** 프로젝트 참여 통계 */
  engagement?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfMediaLinksItemProjectInfoEngagement;
  /** 프로젝트 ID */
  projectId?: number;
};
